import React, { useState } from 'react';
import { Transition } from 'react-transition-group';
import { cn } from '@/lib/utils';

import APPLE_DOWNLOAD from '@/ui/assets/images/apple_download.png';

interface ActionsPopoverProps {
  isOpened: boolean;
  onClose: () => void;
}
const ActionsPopover = ({ isOpened, onClose }: ActionsPopoverProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const downloadApp = () => {
    window.open('https://apps.apple.com/us/app/myproxi/id6470256241/', '_blank');
  };

  const downloadModel = () => {
    setCurrentSlide(1);
  };

  return (
    <Transition in={isOpened} timeout={300}>
      {(state) => (
        <>
          <div 
            className={cn(
              "fixed top-0 left-0 right-0 bottom-0 bg-black/10 z-[9998] transition-opacity duration-300",
              isOpened ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
            )}
            onClick={onClose} 
          />
          <div 
            className={cn(
              "fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-screen z-[9999] max-w-[500px] bg-cream rounded-[30px] shadow-[4px_3px_9px_rgba(0,0,0,0.5)] overflow-hidden transition-opacity duration-300",
              (state === 'entering' || state === 'entered') ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
            )}
          >
            <div className="p-6 pt-6 pb-0 flex justify-end">
              <button className="text-[22px] p-2" onClick={onClose}>x</button>
            </div>
            <div 
              className="flex w-[200vw] max-w-[1000px] transition-transform duration-[400ms] ease-in-out"
              style={{ transform: `translateX(${currentSlide * -50}%)` }}
            >
              <div className="w-screen h-[320px] flex flex-col items-center justify-center px-12 flex-grow-0 flex-shrink-0 max-w-[500px]">
                <h5 className="text-primary-800 text-xl leading-[22px] font-family-bold">
                  We believe that everybody should have a personal AI model ✨
                </h5>
                <p className="text-primary-500 text-xl mt-6 leading-[22px] font-family-text">
                  In the Proxi App, you can create your complete model by talking with Roxi and other characters about
                  any topic, and even by playing games. You can also get personalized AI recommendations 🔮, analysis
                  🧐, custom podcasts 🎙️, creation tools 🎨 and more 🤯
                </p>
              </div>
              <div className="w-screen h-[320px] flex flex-col items-center justify-center px-12 flex-grow-0 flex-shrink-0 max-w-[500px]">
                <h5 className="text-primary-500 text-xl leading-[22px] font-family-bold">
                  We're preparing (the start of) your personal AI model now, and will email it to you shortly. Keep
                  working on it! Thanks for using Proxi ✨
                </h5>
              </div>
            </div>
            <div className="flex items-center justify-center flex-col pb-8">
              <h5 className="text-[15px] leading-5 my-2 text-primary-800 text-center font-family-text">
                continue with Proxi app
              </h5>
              <button onClick={downloadApp}>
                <img src={APPLE_DOWNLOAD} width={134} height={44} alt="Download apple" />
              </button>
              <div 
                className={cn(
                  "transition-opacity duration-[400ms] ease-in-out",
                  currentSlide ? "opacity-0" : "opacity-100"
                )}
              >
                <h5 className="text-[15px] leading-5 my-2 text-primary-800 text-center font-family-text">
                  or
                </h5>
                <button 
                  className="text-[15px] py-[7px] px-4 rounded-[5px] text-primary-500 border-2 border-primary-500"
                  onClick={downloadModel}
                >
                  take model
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </Transition>
  );
};

export default ActionsPopover;
